import { NotificationSocketRepository } from "../repositories/NotificationSocketRepository";

export class ConnectSocketNotification {
	constructor(private repository: NotificationSocketRepository) {}
	execute(): Promise<void> {
		return this.repository.connectSocket();
	}
}
